
export default {
  props: {
    content: String,
    width: Number,
    highlight: String,
    placement: {
      type: String,
      default: 'top-start'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    activable: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      disabledToolTip: true
    };
  },


  computed: {
    highlightContent: function highlightContent() {
      if (this.highlight) {
        // 匹配关键字正则
        var replaceReg = new RegExp(this.highlight, 'gi');
        // 高亮替换v-html值
        return this.content.replace(replaceReg, function (str) {
          return '<span class="highlight">' + str + '</span>';
        });
      }
      return this.content;
    }
  },

  methods: {
    extractTextFromHTML: function extractTextFromHTML(htmlString) {
      // 创建一个虚拟div元素
      var tempDiv = document.createElement('div');
      // 将HTML字符串赋值给div元素的innerHTML属性，这样浏览器会自动将其转换为DOM节点
      tempDiv.innerHTML = htmlString;
      // 使用textContent属性获取元素中的文本
      var extractedText = tempDiv.textContent || tempDiv.innerText || '';
      // 返回过滤后的文本
      return extractedText.replace(/(<([^>]+)>)/gi, '');
    },
    hover: function hover(e) {
      // 谷歌浏览器
      if (e.target) {
        this.disabledToolTip = e.target.clientWidth >= e.target.scrollWidth;
      } else if (e.originalTarget) {
        // 火狐浏览器
        this.disabledToolTip = e.originalTarget.clientWidth >= e.originalTarget.scrollWidth;
      }
    }
  }
};